import { Field } from 'formik';
import { Box, CheckboxGroup, FormControl, SimpleGrid } from '@chakra-ui/react';
import { setOptions } from './utils';
import RSCheckboxField from './RSCheckboxField';
import ElementInstructions from '../components/ElementInstructions';
import ElementHeading from '../components/ElementHeading';
import ElementErrorMessage from '../components/ElementErrorMessage';
import { getResumeOrSectionIndex } from '../../handlers';
import AddAnother from './AddAnother';

const Checkboxes = ({ fieldName, qObj, props }) => {
  const index = getResumeOrSectionIndex(props.stateProps, props.formikProps);
  setOptions(props, qObj, index);
  const style = props.stateProps.expertiseStyles;
  return (
    <Box>
      <Field name={fieldName}>
        {({ field, form }) => {
          /*let val = [];
          val = field.value;*/
          let val = field.value;
          return (
            <FormControl
              isInvalid={form.errors[qObj.id] && form.touched[qObj.id]}
            >

              <ElementHeading qObj={qObj} props={props} />
              <ElementInstructions instructions={qObj.instructions} />
              <Box pt={3}>
                <CheckboxGroup
                  name={`jobSeekerData[${props.index}].${props.qid}`}
                  label={qObj.question}
                  id={qObj.qid}
                  value={val}
                >
                  <SimpleGrid
                    columns={[1, null, 2]}
                    spacingX="40px"
                    spacingY="20px"
                    sx={{ ...style.workExperienceCheckboxGroup }}
                  >
                    {qObj.options.map(option => {
                      return (<RSCheckboxField props={props} qObj={qObj} option={option} />)
                    })}
                  </SimpleGrid>
                  <AddAnother props={props} qObj={qObj} style={style} />
                </CheckboxGroup>
              </Box>
              <ElementErrorMessage form={form} index={qObj.index} qid={qObj.qid} />
            </FormControl>
          );
        }}
      </Field>
    </Box>
  );
};

export default Checkboxes;
